import { createStore } from 'vuex';
import { getPartnerToken, getPartnerRefresh, setPartnerSession, clearPartnerSession } from '@/services/auth/partnerSessionStorage';
import axios from 'axios';
import { WAITER_MODE_STATE_KEY, getPersistedAppState, setPersistedAppState } from '@/services/offline/appState';
import { clearPartnerSessionCache } from '@/services/offline/partnerSessionCache';
import deviceModule from './modules/device';
import localRehearsalModule from './modules/localRehearsal';
import operationalModeModule from './modules/operationalMode';
import emergencyNetworkModule from './modules/emergencyNetwork';
import { stopDeviceHeartbeat } from '@/services/device/deviceHeartbeatService';

async function ComprobarToken(commit) {
  const tokenString = localStorage.getItem('token');
  let token;

  if (tokenString && tokenString !== "null") {
    token = JSON.parse(tokenString);

    try {
      const verify = {
        token: token
      };
      const apiUrl = process.env.VUE_APP_API_URL + '/v1/api/partner/verify';
      console.log(apiUrl)
      await axios.post(apiUrl, verify);
      return true;
    } catch (error) {
      const refresh = localStorage.getItem('refresh');

      if (refresh !== null) {
        const refreshObj = {
          refresh: refresh
        };
        const apiRefresh = process.env.VUE_APP_API_URL + '/v1/api/partner/refresh';

        try {
          const response = await axios.post(apiRefresh, refreshObj);
          commit('login', response.data);
          return true;
        } catch (error) {
          localStorage.setItem('refresh', null);
          localStorage.setItem('token', null);
          console.error(error);
          return false;
        }
      } else {
        console.error('No refresh found in localStorage');
        localStorage.setItem('refresh', null);
        localStorage.setItem('token', null);
        return false;
      }
    }
  } else {
    console.error('No token found in localStorage');
    localStorage.setItem('refresh', null);
    localStorage.setItem('token', null);
    return false;
  }
}


const store = createStore({
  modules: {
    device: deviceModule,
    localRehearsal: localRehearsalModule,
    operationalMode: operationalModeModule,
    emergencyNetwork: emergencyNetworkModule,
  },
  state: {
    token: localStorage.getItem('token'),
    refresh: getPartnerRefresh(),
    partner_token: getPartnerToken(),
    admin_token: localStorage.getItem('admin_token'),
    isLoggedIn: false,
    carrito: 0,
    userAllowedToCancel: false,
    isWaiterMode: false
  },
  mutations: {
    login(state, data) {
      state.isLoggedIn = true;
      if (data.access) {
        console.log("token metido")
        state.partner_token = data.access;
        setPartnerSession(data)
      }
      if (data.refresh && data.refresh != null) {
        console.log("refresh metido")
        state.refresh = data.refresh
        setPartnerSession(data)
      }
    },
    loginAdmin(state, data) {
      state.isLoggedIn = true;
      if (data.access) {
        console.log("token metido")
        state.admin_token = data.access;
        localStorage.setItem('admin_token', data.access)
      }
    },
    loginTable(state, data) {
      state.isLoggedIn = true;
      if (data.access) {
        console.log("token metido")
        state.token = data.access;
        localStorage.setItem('token', data.access)
      }
    },
    logout(state) {
      stopDeviceHeartbeat();
      clearPartnerSession();
      localStorage.setItem('token', null);
      localStorage.removeItem('admin_token');
      clearPartnerSessionCache();
      state.refresh = null;
      state.token = null;
      state.partner_token = null;
      state.admin_token = null;
      state.isLoggedIn = false;
      state.isWaiterMode = false;
      void setPersistedAppState(WAITER_MODE_STATE_KEY, false).catch((error) => {
        console.warn('Unable to persist waiter mode logout state:', error);
      });
    },
    setLoggedIn(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn;
    },
    setUserAllowedToCancel(state, value) {
      state.userAllowedToCancel = value;
    },
    setWaiterMode(state, value) {
      state.isWaiterMode = value;
      void setPersistedAppState(WAITER_MODE_STATE_KEY, Boolean(value)).catch((error) => {
        console.warn('Unable to persist waiter mode state:', error);
      });
    }
  },
  getters: {
    getToken(state) {
      return state.partner_token
    },
    getApiUrl() {
      return process.env.VUE_APP_API_URL
    }
  },
  actions: {
    async initialice({ commit }) {
      const isLoggedIn = await ComprobarToken(commit);
      commit('setLoggedIn', isLoggedIn);
      const waiterMode = await getPersistedAppState(WAITER_MODE_STATE_KEY);
      commit('setWaiterMode', Boolean(waiterMode));
    },
    setToken({ commit, dispatch }, data) {
      commit('login', data);
      void dispatch('device/loadCurrentDevice')
        .then(() => Promise.all([
          dispatch('device/initializeDevicePresence'),
          dispatch('device/initializeOperationalAccess'),
        ]))
        .catch(() => {});
    },
    setTokenAdmin({ commit }, data) {
      commit('loginAdmin', data);
    },
    setTokenTable({ commit }, data) {
      commit('loginTable', data);
    },
    TokenBueno({ commit }) {
      commit('TokenBueno');
    },
    setUserAllowedToCancel({ commit }, value) {
      commit('setUserAllowedToCancel', value);
    }
  }
});

export default store;
